
const Login = () => {
  return (
    <div className="relative h-screen flex justify-center items-center">
      <video
        autoPlay
        loop
        muted
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/anim.mp4" type="video/mp4" />
      </video>
   


   
      <div className='relative z-10 w-[450px] h-auto rounded shadow-xl bg-white flex flex-col justify-center items-center'>
      
      <div className='mb-12'>
      <div className="text-center mb-4 mt-10">
      <img className='w-48 h-auto mx-auto' src='/logoGU.png' alt="Logo" />
    </div>
      <div className="mb-10">
        <div className=' font-semibold mb-4'>Adresse e-mail</div>
        
        <input className='mt-2 w-96 h-10 border-2 border-gray-200 hover:border-[#0F6CBD]' type="email" placeholder="Tapez Votre Email" />
    
      </div>

      <div className=" w-96" controlId="formBasicPassword">
        <div className=' font-semibold mt-4 mb-4'>Mot de passe</div>
        <input className='mt-2 w-96 h-10 border-2 border-gray-200 hover:border-[#0F6CBD]'  type="password" placeholder="Tapez Votre Mot de passe" />
      </div>
      
      <div className="text-sm w-96" controlId="formBasicCheckbox">
      <div className='flex flex-r gap-2 mb-16'> <input type="checkbox" label="Se souvenir de moi" />Se souvenir de moi </div> 
     
     
      </div>
      <div className='flex justify-center align-middle mt-8'>
      <button className=' font-semibold bg-[#0F6CBD] hover:bg-opacity-65 w-56 h-12 rounded text-white' variant="primary" type="submit">
       Se Connecter 
      </button>
      </div>
      <a className='text-sm underline mt-1 flex justify-center align-middle  '>Mot de passe oublié?</a>
      
    </div>
       <div className="mt-2 text-center">
    <p className='mb-10'>
      Vous n'avez pas de compte? <a className='text-[#0F6CBD] underline' href='/Signup'>S'inscrire</a>
    </p>
  
  </div>   </div>
    </div>
  );
}

export default Login;
